import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.constructor";
import "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/core-js/modules/es6.array.iterator.js";
import "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/core-js/modules/es6.promise.js";
import "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/core-js/modules/es6.object.assign.js";
import "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import Cookies from 'js-cookie';
import 'normalize.css/normalize.css'; // a modern alternative to CSS resets

import Element from 'element-ui';
import "./assets/styles/element-variables.scss";
import '@/assets/styles/index.scss'; // global css
import '@/assets/styles/ruoyi.scss'; // ruoyi css

import eIconPicker from 'e-icon-picker';
import "e-icon-picker/lib/symbol.js"; //基本彩色图标库
import 'e-icon-picker/lib/index.css'; // 基本样式，包含基本图标
import 'font-awesome/css/font-awesome.min.css'; //font-awesome 图标库
import 'element-ui/lib/theme-chalk/icon.css'; //element-ui 图标库

import { ENUM } from '@/utils/enum';
import common from '@/utils/common';
import api from '@/api';
import mitt from 'mitt';
import App from "./App";
import store from "./store";
import router from "./router";
import permission from "./directive/permission";
import "./assets/icons"; // icon
import "./permission"; // permission control
import { getDicts } from "@/api/system/dict/data";
import { getItems, setItems } from '@/api/items';
import { getConfigKey } from "@/api/system/config";
import { parseTime, resetForm, addDateRange, selectDictLabel, download, handleTree, getUpFileUrl, handleTreeRmEmpty, selectItemsLabel } from "@/utils/ruoyi";
import Pagination from "@/components/Pagination";
var emitter = mitt();
// 全局方法挂载
Vue.prototype.ENUM = ENUM;
Vue.prototype.$emitter = emitter;
Vue.prototype.getDicts = getDicts;
Vue.prototype.getItems = getItems;
Vue.prototype.setItems = setItems;
Vue.prototype.getConfigKey = getConfigKey;
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.addDateRange = addDateRange;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.selectItemsLabel = selectItemsLabel;
Vue.prototype.download = download;
Vue.prototype.handleTree = handleTree;
Vue.prototype.handleTreeRmEmpty = handleTreeRmEmpty;
Vue.prototype.getUpFileUrl = getUpFileUrl;
Vue.prototype.apiUrl = process.env.VUE_APP_BASE_API;
Vue.prototype.msgSuccess = function (msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "success"
  });
};
Vue.prototype.msgError = function (msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "error"
  });
};
Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
};

// 全局组件挂载
Vue.component('Pagination', Pagination);
Vue.use(eIconPicker, {
  FontAwesome: true,
  ElementUI: true,
  eIcon: true,
  eIconSymbol: true
});
Vue.use(common).use(api);
Vue.use(permission);

// 全局弹窗
import Popup from "./components/popup/index";
Vue.prototype.$dialog = Popup.install;

// 修正url链接中的地址
Vue.filter("urlCorrection", function (url) {
  if (/^http|^blob/.test(url)) {
    return url;
  } else {
    var reg = new RegExp('^/*' + Vue.prototype.apiUrl + "/*");
    return Vue.prototype.apiUrl + "/" + url.replace(reg, '');
  }
});

// 时间格式化
var dayjs = require('dayjs');
Vue.filter('formateTime', function (data) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
  return dayjs(data).format(format);
});
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
});
Vue.config.productionTip = false;
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});